import React from 'react';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import FieldLabel from '../components/FieldLabel';
import { outlinedFieldProps, disabledOutlinedSx } from '../utils/fieldStyles';

const getDurationHours = (start, end) => {
    if (!start || !end) return '';

    const [startHour, startMinute] = start.split(':').map(Number);
    const [endHour, endMinute] = end.split(':').map(Number);

    const startTotalMinutes = startHour * 60 + startMinute;
    let endTotalMinutes = endHour * 60 + endMinute;

    if (endTotalMinutes < startTotalMinutes) {
        endTotalMinutes += 24 * 60;
    }

    const durationHours = (endTotalMinutes - startTotalMinutes) / 60;
    return Number(durationHours.toFixed(2));
};

const DurationCalcField = ({ field, data }) => (
    <Grid container spacing={2}>
        <Grid item xs={12}>
            <TextField
                {...outlinedFieldProps}
                label={<FieldLabel label={field.label} tooltip={field.tooltip} />}
                value={getDurationHours(data.start_time, data.end_time)}
                disabled
                sx={disabledOutlinedSx}
            />
        </Grid>
    </Grid>
);

export default DurationCalcField;
